// extracted by mini-css-extract-plugin
module.exports = {"Recipe":"skv5UmTqZoZxfw838njCv","error":"DSSHzUMJZAsU5aWnbYj6L","header":"_1WN1VSHW66fgNwKNNg0X2J","ings":"JBbiblbmg_MV6RtSdij2F","instructions":"MITOQgYwan_2nRuu90jr2"};